import { NavLink } from 'react-router-dom'
import DataTable from '../../../common/data-table/DataTable'
import PageHeader from '../../../layout/page/PageHeader'
import dayjs from 'dayjs'
import { FilterMatchMode } from 'primereact/api'
import { Calendar } from 'primereact/calendar'
import { Alert, ButtonGroup } from 'react-bootstrap'
import { useState } from 'react'
import DeleteDialog from '../../../common/dialogs/DeleteDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

const Pages = () => {
    const [refreshTable, setRefreshTable] = useState(false)

    const dateTimeBodyTemplate = (rowData) => {
        return rowData.created_at !== null
            ? dayjs(rowData.created_at).format('DD-MMM-YYYY @ HH:mm:ss')
            : ''
    }

    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => options.filterCallback(e.value, options.index)}
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
                mask="99/99/9999"
            />
        )
    }

    const actionsBodyTemplate = (rowData) => {
        return (
            <ButtonGroup size="sm">
                <DeleteDialog
                    url={'/page-components/pages/delete/' + rowData.id}
                    record={rowData}
                    deletedCallback={() => setRefreshTable(true)}
                    confirmText={rowData.code}
                    message={
                        <>
                            <p className="mb-3 pb-3 border-bottom">
                                Are you sure you want to delete page:
                                <strong> {rowData.name}</strong>?
                            </p>
                            <Alert variant="warning" className="border-0">
                                <strong>Warning!</strong> All sections related
                                to this page will be deleted permenantly!
                            </Alert>
                        </>
                    }
                />
                <NavLink
                    to={'/content/pages/view/' + rowData.id}
                    className="btn btn-outline-primary ms-1"
                >
                    <FontAwesomeIcon icon={faEdit} />
                </NavLink>
            </ButtonGroup>
        )
    }

    return (
        <>
            <PageHeader
                icon="file-lines"
                subtitle="Manage your website pages"
                header="Pages"
                buttons={[
                    {
                        variant: 'success',
                        label: 'Create New',
                        icon: 'fa-solid fa-plus',
                        url: '/content/pages/new',
                    },
                ]}
            />
            <DataTable
                refreshTable={refreshTable}
                config={{
                    dataRoute: '/page-components/pages',
                    first: 0,
                    rows: 10,
                    page: 0,
                    sortField: 'name',
                    sortOrder: 1,
                    filters: {
                        global: {
                            value: null,
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        name: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        code: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        updated_at: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                    },
                    filterDisplay: 'menu',
                }}
                columns={[
                    // {
                    //     field: 'select-fields',
                    //     header: 'Select',
                    //     selectionMode: 'multiple',
                    //     headerStyle: { width: '3rem' },
                    //     excludeFromShowHide: true
                    // },
                    // {
                    //     field: 'code',
                    //     header: 'code',
                    //     sortable: true,
                    //     filter: true,
                    //     filterPlaceholder: 'Search',
                    // },
                    {
                        field: 'name',
                        header: 'Name',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                    },
                    // {
                    //     field: 'created_at',
                    //     header: 'Date Created',
                    //     sortable: true,
                    //     filter: true,
                    //     filterPlaceholder: 'Search',
                    //     body: dateTimeBodyTemplate,
                    // },
                    {
                        field: 'updated_at',
                        header: 'Last Updated',
                        sortable: true,
                        filter: true,
                        // filterPlaceholder: 'Search',
                        dataType: 'date',
                        body: dateTimeBodyTemplate,
                        filterElement: dateFilterTemplate,
                        style: {
                            maxWidth: '3rem',
                        },
                    },
                    // {
                    //     field: 'representative.name',
                    //     header: 'Representative',
                    //     sortable: true,
                    //     filter: true,
                    //     filterPlaceholder: 'Search',
                    //     body: representativeBodyTemplate,
                    // },
                    {
                        field: 'id',
                        header: 'Actions',
                        sortable: false,
                        body: actionsBodyTemplate,
                        alignHeader: 'center',
                        headerStyle: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        style: {
                            maxWidth: '1.2rem',
                            textAlign: 'center',
                        },
                        toggleVisibility: false,
                    },
                ]}
                globalFilterFields={['name', 'updated_at']}
            />
        </>
    )
}

export default Pages
